// V1.4 D4: Read HOTLINE_PHONE_NUMBER live from /cms/system-parameter/list
// so Admin can change it via the SystemParameter UI without a redeploy.
// Falls back to the constants/common.ts value if the API is unreachable
// (offline forgot-password popup still works).
import { useQuery } from '@tanstack/react-query';

import { axiosClient } from '@/api/axiosClient';
import { HOTLINE_PHONE_NUMBER as DEFAULT_HOTLINE } from '@/constants';

interface SystemParameter {
  code: string;
  value: string;
}

export function useHotline(): string {
  const { data } = useQuery(
    ['system-param-hotline'],
    () => axiosClient.get<SystemParameter[]>('/system-parameter/list'),
    {
      // Hotline rarely changes; 5-minute cache stops a popup-open from
      // refetching mid-call.
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    }
  );

  // axiosClient returns the full BE envelope { status, message, data }, so
  // we access `.data` to reach the actual array.
  const list = (data as unknown as { data?: SystemParameter[] })?.data ?? [];
  const found = list.find((p) => p.code === 'HOTLINE_PHONE_NUMBER');

  return found?.value || DEFAULT_HOTLINE;
}
